// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
// Service
import { SystemApiService } from '../../../service/system-api.service';
import { ErrorFactoryService } from '../../../service/error-factory.service';
// Model
import { ErrorCodeModel } from '../../../error-track/model/error-code.model';
// Other
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const CLASS_VALUATION_PROVIDER = 'classvaluation';

@Injectable({ providedIn: 'root' })
export class UsersService {
	constructor(
		private httpClient: HttpClient,
		private errorFactory: ErrorFactoryService,
		private systemApiService: SystemApiService
	) {
		// Still silence is golden.
	}

	/**
	 * GET - Return the user data from id
	 */
	getUser(provider: string, id: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.identitySystemService}${provider}/users/me`
		).pipe(
			map((resp: any) => {
				return resp;
			}),
			catchError((error: HttpErrorResponse) => {
				return throwError( () =>
					this.errorFactory.throwErrorExceptionCode(error, ErrorCodeModel.E002)
				);
			})
		);
	}
}
